import { createFileRoute, notFound, Outlet } from "@tanstack/react-router"
import { shouldBypassMedusaRegionLoader } from "@/lib/utils/static-routes"

const STATIC_COUNTRY_CODES = new Set(["us"])

export const Route = createFileRoute("/$countryCode")({
  loader: async ({ params, context, location }) => {
    const { countryCode } = params
    const { queryClient } = context

    if (shouldBypassMedusaRegionLoader(location.pathname)) {
      if (!STATIC_COUNTRY_CODES.has(countryCode.toLowerCase())) {
        throw notFound()
      }
      return { countryCode }
    }

    // Get all regions to validate country code
    const { listRegions } = await import("@/lib/data/regions")

    const regions = await queryClient.ensureQueryData({
      queryKey: ["regions"],
      queryFn: () => listRegions({ fields: "currency_code, *countries" }),
    })

    // Check if country code is valid
    const isValidCountry = regions.some(
      region => region.countries?.some(
        country => country.iso_2 === countryCode.toLowerCase()
      )
    )

    if (!isValidCountry) {
      throw notFound() // Show 404 for invalid countries
    }

    // Valid country - proceed to child routes
    return { countryCode }
  },
  component: () => <Outlet />,
})
